import { request } from 'data/requests/request';

export interface IReturnSubmitItem {
    id: string;
    qty: number;
}

export interface IReturnSubmitPayload {
    orderNumber: string;
    email: string;
    phone: string;
    firstName: string;
    lastName: string;
    reason: string;
    bankAccount: string;
    confirmed: boolean;
    items: IReturnSubmitItem[];
}

export interface IReturnSubmitResponse {
    success?: boolean;
    error?: string;
}

const submitReturnRequest = (payload: IReturnSubmitPayload, captchaToken: string) =>
    request({
        type: 'orderReturnSubmit',
        url: 'orderreturns/form/submit',
        data: payload,
        method: 'POST',
        notApi: true,
        force: true,
        headers: { 'X-ReCaptcha': captchaToken },
    });

export default submitReturnRequest;
